export class ModuleValidations_Access {

    constructor() {

        // access module from gd.modules.xxx....
    }

    //
    get canModifySettings():boolean {
        return gd.user.acl.isManager
    }




}

